export default __webpack_public_path__ + "static/winter0-543035e9945b360c1220f2a522b19a2d.webp";